<template>
    <fragment>
        <out-put-page
            title="Étude technique"
            sectionRef="moyen_dexploitation"
            v-on:page-updated="handleAfterRender"
        >
            <section v-if="moyensFonciersEtImmeubles.length > 0">
                <h3>Moyens Fonciers et immeubles</h3>
                <land-and-building-cards
                    :buildings="moyensFonciersEtImmeubles"
                />
            </section>
        </out-put-page>
    </fragment>
</template>

<script>
import Vue from "vue";
import SectionTitleTable from "../components/SectionTitleTable";
import OutPutPage from "../components/OutPutPage";
import LandAndBuildingCards from "../components/LandAndBuildingCards";
import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import DataTable from "../components/DataTable";

const pageContentHeight = 1550;
const OutPageComponent = Vue.extend(OutPutPage);
const TableComponent = Vue.extend(SectionTitleTable);
const DataTableComponent = Vue.extend(DataTable);
export default {
    components: {
        // eslint-disable-next-line
        SectionTitleTable,
        OutPutPage,
        LandAndBuildingCards
    },
    props: {
        moyensExploitation: {
            type: Object,
            required: true
        },
        moyensFonciersEtImmeubles: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: [],
            renderTrigger: ""
        };
    },

    mounted() {
        const itmoTableData = this.initITMOTableData();
        const MIAndMBTableData = this.initMIAndMBTableData();
        const moyensHumainsTabelData = this.initMoyenHumain();
        const $vm = this;
        this.data.push(
            {
                data: itmoTableData,
                prevData: this.data[0],
                currentIndex: 0,
                firstItemLock: true,
                currentHeader: {},
                seederConter: 0,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    if (!Array.isArray(this.data[0])) {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentHeader = cloneDeep(data);

                        if (this.seederConter !== 0) this.currentIndex++;
                        this.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data[
                            this.currentIndex
                        ].content.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                    this.seederConter++;
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                initHeader() {
                    this.componentInstance.$props.tables.data.push(
                        this.currentHeader
                    );
                },
                pop() {
                    this.componentInstance.$props.tables.data[
                        this.currentIndex
                    ].content.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.componentInstance = new TableComponent({
                        propsData: {
                            tables: {
                                headers: [
                                    { title: "Type", type: "String" },
                                    { title: "Désignation", type: "String" },
                                    { title: "Nombres", type: "String" },
                                    {
                                        title: "Caractéristiques",
                                        type: "String"
                                    },
                                    { title: "Prix(HT)", type: "Currency" },
                                    { title: "Fournisseur", type: "String" },
                                    { title: "Origine", type: "String" },
                                    { title: "Avance", type: "Currency" },
                                    {
                                        title: "Loyer mensuel",
                                        type: "Currency"
                                    },
                                    { title: "Durée", type: "String" }
                                ],
                                data: []
                            }
                        }
                    });
                    if (!this.firstItemLock) this.initHeader();
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude technique",
                            sectionRef: "moyen_dexploitation"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.moyen_dexploitation.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML = "Moyens d'exploitation";
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            },
            {
                data: MIAndMBTableData,
                prevData: this.data[0],
                currentIndex: 0,
                currentHeader: {},
                firstItemLock: true,
                seederConter: 0,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    if (!Array.isArray(this.data[0])) {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentHeader = cloneDeep(data);
                        if (this.seederConter !== 0) this.currentIndex++;
                        this.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data[
                            this.currentIndex
                        ].content.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                    this.seederConter++;
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.tables.data[
                        this.currentIndex
                    ].content.pop();
                    this.data = [this.prevData, ...this.data];
                },
                initHeader() {
                    this.componentInstance.$props.tables.data.push(
                        this.currentHeader
                    );
                },
                componentInstance: "",
                initComponent() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    this.componentInstance = new TableComponent({
                        propsData: {
                            tables: {
                                headers: [
                                    { title: "Désignation", type: "String" },
                                    { title: "Nombres", type: "String" },
                                    {
                                        title: "Caractéristiques",
                                        type: "String"
                                    },
                                    { title: "Prix(HT)", type: "Currency" },
                                    { title: "Fournisseur", type: "String" },
                                    { title: "Origine", type: "String" }
                                ],
                                data: []
                            }
                        }
                    });
                    if (!this.firstItemLock) this.initHeader();
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude technique",
                            sectionRef: "moyen_dexploitation"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.moyen_dexploitation.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const PartnersSection = document.createElement("section");
                    if (!this.firstItemLock) {
                        const PartnersSectionTitle = document.createElement(
                            "h3"
                        );
                        PartnersSectionTitle.innerHTML =
                            "Moyens d'exploitation";
                        PartnersSection.appendChild(PartnersSectionTitle);
                    }

                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            },
            {
                data: moyensHumainsTabelData,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                        this.prevData = data;
                        this.data.shift();
                        if (this.isEmpty()) {
                            $vm.data.shift();
                        }
                    });
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.tables.data.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    this.componentInstance = new DataTableComponent({
                        propsData: {
                            tables: {
                                headers: [
                                    { title: "Fonctions", type: "String" },
                                    {
                                        title: "Effectif",
                                        type: "String"
                                    },
                                    {
                                        title: "Salaire brut mensuel (DH)",
                                        type: "Currency"
                                    }
                                ],
                                data: []
                            }
                        }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude technique",
                            sectionRef: "moyen_dexploitation"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    newPage.$el.classList.add("landscape");

                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.moyen_dexploitation.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML = "Moyens humains";
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            }
        );

        this.handleAfterRender();
    },
    methods: {
        handleAfterRender(contentHeight) {
            for (const instance of this.data) {
                if (instance.firstItemLock && instance.data.length > 0) {
                    instance.initComponent();
                    if (pageContentHeight - contentHeight < 300)
                        instance.newPage();
                    instance.initSection();
                    instance.firstItemLock = false;
                }
                if (contentHeight >= pageContentHeight) {
                    instance.pop();
                    instance.initComponent();
                    instance.newPage();
                    instance.initSection();
                    instance.seed(instance.prevData);
                } else {
                    instance.seed();
                }
                break;
            }
        },
        initITMOTableHeaders() {
            const headers = [];
            const {
                installations_techniques,
                materiels_et_outillage,
                moyens_de_transports
            } = this.moyensExploitation;
            if (installations_techniques.length > 0)
                headers.push({
                    title: "Installation technique",
                    content: []
                });
            if (materiels_et_outillage.length > 0)
                headers.push({
                    title: "Matériels et outillage",
                    content: []
                });
            if (moyens_de_transports.length > 0)
                headers.push({
                    title: "Moyens de transport et manutention",
                    content: []
                });
            return headers;
        },
        initMIAndMBTableHeaders() {
            const headers = [];
            const {
                mobilier_et_bureaux,
                materiel_informatique
            } = this.moyensExploitation;
            if (mobilier_et_bureaux.length > 0)
                headers.push({
                    title: "Mobilier et bureaux",
                    content: []
                });
            if (materiel_informatique.length > 0)
                headers.push({
                    title: "Matériel Informatique",
                    content: []
                });
            return headers;
        },
        initMIAndMBTableData() {
            const keysOrder = [
                "designation",
                "nombre",
                "caracteristique",
                "prix",
                "nomFournisseur",
                "origine"
            ];
            const moyenExploitation = [];
            const {
                mobilier_et_bureaux,
                materiel_informatique
            } = this.moyensExploitation;

            if (
                !(
                    mobilier_et_bureaux.length +
                        materiel_informatique.length ===
                    0
                )
            ) {
                if (mobilier_et_bureaux.length > 0)
                    moyenExploitation.push({
                        title: "Mobilier et bureaux",
                        content: []
                    });

                mobilier_et_bureaux.forEach(item => {
                    moyenExploitation.push(
                        keysOrder.map(elem => {
                            return item[`${elem}`];
                        })
                    );
                });

                if (materiel_informatique.length > 0)
                    moyenExploitation.push({
                        title: "Matériel Informatique",
                        content: []
                    });

                materiel_informatique.forEach(item => {
                    moyenExploitation.push(
                        keysOrder.map(elem => {
                            return item[`${elem}`];
                        })
                    );
                });
            }
            return moyenExploitation;
        },
        initITMOTableData() {
            const keysOrder = [
                "isBuying",
                "designation",
                "number",
                "characteristics",
                "price",
                "providerName",
                "origin",
                "payedInAdvance",
                "rentPrice",
                "rentDuration"
            ];
            const moyenExploitation = [];
            const {
                installations_techniques,
                materiels_et_outillage,
                moyens_de_transports
            } = this.moyensExploitation;

            if (
                !(
                    installations_techniques.length +
                        materiels_et_outillage.length +
                        moyens_de_transports.length ===
                    0
                )
            ) {
                if (installations_techniques.length > 0)
                    moyenExploitation.push({
                        title: "Installation technique",
                        content: []
                    });
                installations_techniques.forEach(item => {
                    moyenExploitation.push(
                        keysOrder.map(elem => {
                            if (elem === "isBuying")
                                return item[`${elem}`] === true
                                    ? "Achat"
                                    : "Leasing";
                            return item[`${elem}`];
                        })
                    );
                });
                if (materiels_et_outillage.length > 0)
                    moyenExploitation.push({
                        title: "Matériels et outillage",
                        content: []
                    });
                materiels_et_outillage.forEach(item => {
                    moyenExploitation.push(
                        keysOrder.map(elem => {
                            if (elem === "isBuying")
                                return item[`${elem}`] === true
                                    ? "Achat"
                                    : "Leasing";
                            return item[`${elem}`];
                        })
                    );
                });

                keysOrder[0] = "BuyingType";
                if (moyens_de_transports.length > 0)
                    moyenExploitation.push({
                        title: "Moyens de transport et manutention",
                        content: []
                    });
                moyens_de_transports.forEach(item => {
                    moyenExploitation.push(
                        keysOrder.map(elem => {
                            return item[`${elem}`];
                        })
                    );
                });
            }
            return moyenExploitation;
        },
        initMoyenHumain() {
            const keysOrder = ["name", "effective", "salary"];
            const moyensHumains = [];
            const { moyens_humains } = this.moyensExploitation;
            moyens_humains.forEach(item => {
                moyensHumains.push(
                    keysOrder.map(elem => {
                        return item[`${elem}`];
                    })
                );
            });
            return moyensHumains;
        }
    }
};
</script>

<style></style>
